import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/CookiesBanner.css';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  // Función para leer cookies
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  // Verifica si la cookie ya está aceptada
  useEffect(() => {
    const accepted = getCookie('cookiesAccepted');
    if (!accepted) {
      setShowBanner(true);
    }
  }, []);

  // Función para aceptar cookies y guardarlas
  const handleAccept = () => {
    const expiration = new Date();
    expiration.setFullYear(expiration.getFullYear() + 1);
    document.cookie = `cookiesAccepted=true; expires=${expiration.toUTCString()}; path=/`;
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div className="cookie-banner">
        <p className="cookie-text">
          Usamos cookies para mejorar tu experiencia. Al continuar, aceptas nuestro{' '}
            <Link to="/politica-cookies" className="cookie-link">Política de Cookies</Link>.
        </p>
        <button className="cookie-button" onClick={handleAccept}>
          Aceptar
        </button>
      </div>
    )
  );
};

export default CookieBanner;
